import $ from 'jquery';

export default function hero() {
  let parallax = -0.1;

  let $bg_images = $('.block-hero--startpage .hero__img img');
  let offset_tops = [];
  $bg_images.each(function(i, el) {
    offset_tops.push($(el).offset().top);
  });

  $(window).scroll(function() {
    let dy = $(this).scrollTop();
    $bg_images.each(function(i, el) {
      let ot = offset_tops[i];
      $(el).css('object-position', '50% ' + (dy - ot) * parallax + 'px');
    });
  });
}
